// Hero.jsx

import React from "react";
import styled from "styled-components";

const HEADER_COMPENSATION = "5rem";

const HeroSection = styled.section`
  margin-top: ${HEADER_COMPENSATION};
  min-height: calc(100vh - ${HEADER_COMPENSATION});

  transform: none;
  padding-top: 0;
  padding-bottom: 0;

  max-width: 900px;
  margin-left: auto;
  margin-right: auto;

  display: flex;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;

  padding-left: 1.5rem;
  padding-right: 1.5rem;
  align-items: center;

  /* Адаптивное смещение текста вниз на мобильных */
  @media (max-width: 640px) {
    /* Сброс стилей ПК */
    margin-top: 0;
    min-height: 100vh;

    /* Мобильные стили */
    align-items: flex-start;
    padding-top: 8rem;
  }
`;

const BackgroundImage = styled.img`
  /* Стили для десктопа */
  position: absolute;
  top: 5rem;
  right: 0;
  width: 60%;
  max-width: 24rem;
  height: 83.333333%;
  object-fit: cover;
  filter: none !important;
  @media (max-width: 640px) {
    width: 100%;
    max-width: 100%;
    height: 70vh;
    opacity: 0.35;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    object-fit: contain;
    object-position: center;
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 10;
  max-width: 36rem;

  /* Смещаем текстовый блок вниз на мобильных */
  @media (max-width: 640px) {
    margin-top: 35vh;
    max-width: 90%;
  }
`;

const Title = styled.h2`
  font-weight: 700;
  font-family: "Monserat", cursive;
  font-size: 2.5rem;
  image-rendering: pixelated !important;
  -ms-interpolation-mode: nearest-neighbor !important;
  margin-bottom: 1rem;
  color: var(--color-text);
  @media (max-width: 640px) {
    font-size: 1.7rem;
  }
`;

const GradientContainer = styled.div`
  position: relative;

  /* Градиентный эффект */
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: linear-gradient(
      to top,
      rgba(255, 255, 255, 0.9) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  /* Градиент для Темной темы */
  body.dark-theme &::before {
    background-image: linear-gradient(
      to top,
      rgba(26, 26, 26, 0.9) 0%,
      rgba(26, 26, 26, 0) 100%
    );
  }

  /* Убираем отступ и градиент на мобильных */
  @media (max-width: 640px) {
    padding-left: 0;
    &::before {
      content: none;
    }
  }
`;

const Paragraph = styled.p`
  position: relative;
  z-index: 1;
  font-size: 1.7rem;
  line-height: 1.75rem;
  letter-spacing: -1px;
  font-family: "Monserat";
  color: var(--color-text);

  /* тень для светлой темы */
  text-shadow: 2px 2px 2px rgba(250, 250, 250, 0.8);
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.05));

  /* тень для темной темы */
  body.dark-theme & {
    text-shadow: 2px 2px 2px rgba(26, 26, 26, 0.8);
    filter: drop-shadow(2px 2px 2px rgba(255, 255, 255, 0.15));
  }

  @media (max-width: 640px) {
    font-size: 1.2rem;
  }
`;

const Highlight = styled.span`
  color: #02861fff;
  font-weight: 400;
  font-family: "PixelFont", cursive;
  font-size: 1rem;

  /* акцентный цвет для темной темы */
  body.dark-theme & {
    color: #38c838ff;
  }
  @media (max-width: 640px) {
    font-size: 0.8rem;
  }
`;

export default function Hero() {
  return (
    <HeroSection id="hero">
      <BackgroundImage src="./images/back.png" alt="Eziz" />

      <ContentWrapper>
        <Title>Привет! Я Eziz</Title>
        <GradientContainer>
          <Paragraph>
            и я — Frontend-разработчик. Моя страсть? Создавать минималистичные
            интерфейсы и писать элегантный <Highlight> &lt;code&gt;</Highlight>.
            Давайте что-нибудь построим!
          </Paragraph>
        </GradientContainer>
      </ContentWrapper>
    </HeroSection>
  );
}
